import { AlertCircle, FileEdit } from 'lucide-react';
import React from 'react';

interface ErrorDisplayProps {
  message: string;
  isDraft?: boolean;
}

const ErrorDisplay: React.FC<ErrorDisplayProps> = ({ message, isDraft = false }) => (
  <div className="flex h-full w-full flex-col items-center justify-center">
    {isDraft ? <FileEdit className="mb-2 h-12 w-12" /> : <AlertCircle className="mb-2 h-12 w-12" />}
    <p className="text-sm">{message}</p>
  </div>
);

export default ErrorDisplay;
